import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import SignInCallback from '../component/oidc/components/signin-callback';
import { silentRenewalCallback } from '../component/oidc/usermanager/oidc-client-usermanager';
import SalesOnboardingPartner from '../component/sales/sales-onboarding-partner';
import PartnerOnboarding from '../component/partner/partner-onboarding';
import NotFound from '../common/not-found/not-found';

const ApplicationRoutes = () => (
  <Router>
    <Switch>
      <Route path="/sign-in-callback" component={SignInCallback} />
      <Route path="/silent-renewal-callback" component={silentRenewalCallback} />
      <Route path="/sales-onboarding-partner/:id?" component={SalesOnboardingPartner} />
      <Route path="/partner-onboarding/:id?" component={PartnerOnboarding} />
      <Route component={NotFound} />
    </Switch>
  </Router>
);

export default ApplicationRoutes;
